<div class="box">
  <mat-sidenav-container>
    <mat-sidenav #sidenav role="navigation">
      <app-sidenav (sidenavClose)="sidenav.close()"></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content>
      <main>
        <app-sidebar>
          <app-header (sidenavToggle)="sidenav.toggle()"></app-header>
          <div class="content">
            <router-outlet></router-outlet>
          </div>
        </app-sidebar>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- <div class="container">
  <app-nav-bar></app-nav-bar>
  <div class="layout">
    <div class="sidebar">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header class="nav-tem">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/dashboard.svg"
                  alt="not"
                />
                <div>Dashboard</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/profile']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              >Dashboard
            </a>
            <a
              [routerLink]="['/print-receipt']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Front Desk' ||
                role == 'Scan' ||
                role == 'X-ray' ||
                role == 'Cashier' ||
                role == 'Lab Scientist' ||
                role == 'Lab Supervisor' ||
                role == 'Lab' ||
                role == 'Result Typing' ||
                role == 'Dispatch' ||
                role == 'Result Printing'
              "
              >Payments
            </a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="role == 'Administrator' || role == 'Front Desk'">
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-tem">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/settings.svg"
                  alt="not"
                />
                <div>Setup</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              (click)="openTitle()"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Title
            </a>
            <a (click)="opendrop()" *ngIf="role == 'Administrator'"
              >Dropdown / Values
            </a>
            <a (click)="openVoucher()" *ngIf="role == 'Administrator'"
              >Voucher</a
            >
            <a (click)="openCity()" *ngIf="role == 'Administrator'">City </a>
            <a (click)="openState()" *ngIf="role == 'Administrator'">State</a>
            <a (click)="openCountry()" *ngIf="role == 'Administrator'"
              >Country</a
            >
            <a (click)="openBank()" *ngIf="role == 'Administrator'">Bank</a>
            <a (click)="openCard()" *ngIf="role == 'Administrator'"
              >Card Type</a
            >
            <a (click)="openCategory()" *ngIf="role == 'Administrator'"
              >Cartegory</a
            >
            <a (click)="openEmployee()" *ngIf="role == 'Administrator'"
              >Employee</a
            >
            <a (click)="openCompany()" *ngIf="role == 'Administrator'"
              >Company</a
            >
            <a (click)="openBranch()" *ngIf="role == 'Administrator'">Branch</a>
            <a (click)="openDept()" *ngIf="role == 'Administrator'"
              >Department</a
            >
            <a (click)="openSub()" *ngIf="role == 'Administrator'"
              >Sub Department</a
            >
            <a (click)="openSpecial()" *ngIf="role == 'Administrator'"
              >Specialazation</a
            >
            <a (click)="openSoc()" *ngIf="role == 'Administrator'">SOC</a>
            <a (click)="openUom()" *ngIf="role == 'Administrator'">UOM</a>
            <a
              (click)="openItem()"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Item</a
            >
            <a
              (click)="openRefDr()"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Referral Dr</a
            >
            <a (click)="openGroups()" *ngIf="role == 'Administrator'">Groups</a>
            <a (click)="openAloc()" *ngIf="role == 'Administrator'"
              >Alocated SOC</a
            >
            <a (click)="openOpd()" *ngIf="role == 'Administrator'">OPD</a>
            <a (click)="openNational()" *ngIf="role == 'Administrator'"
              >National</a
            >
            <a (click)="openSale()" *ngIf="role == 'Administrator'"
              >Sales Card</a
            >
            <a (click)="openDetail()" *ngIf="role == 'Administrator'"
              >OPD Detail</a
            >
            <a (click)="openSetup()" *ngIf="role == 'Administrator'">Setup</a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion
        *ngIf="role == 'self-service user' || role == 'self-service consultant'"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-tem">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/settings.svg"
                  alt="not"
                />
                <div>Self Service</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a (click)="openPointment()" *ngIf="role == 'self-service user'"
              >Appointments
            </a>
            <a (click)="bookApointment()" *ngIf="role == 'self-service user'"
              >Book Appointments
            </a>
            <a
              [routerLink]="['/online-finalise']"
              *ngIf="role == 'self-service consultant'"
              >Result Finalize</a
            >
            <a
              [routerLink]="['/online-view-result']"
              *ngIf="role == 'self-service user'"
              >View Result</a
            >
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="role == 'Administrator' || role == 'Lab Scientist'">
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-item">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/promotion.svg"
                  alt="not"
                />
                <div>Communication</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a (click)="openLocalPointment()" *ngIf="role == 'Administrator'"
              >Appointments
            </a>
            <a [routerLink]="['/email']" *ngIf="role == 'Administrator'"
              >Email</a
            >
            <a [routerLink]="['/sms']" *ngIf="role == 'Administrator'">SMS</a>
            <a
              [routerLink]="['/result']"
              *ngIf="role == 'Administrator' || role == 'Lab Scientist'"
              >Result</a
            >
            <a
              [routerLink]="['/ft-single-result']"
              *ngIf="role == 'Administrator'"
              >FT Single Result (OBS)</a
            >
            <a
              [routerLink]="['/ft-twin-result']"
              *ngIf="role == 'Administrator'"
              >FT Twin Result (OBS)</a
            >
            <a
              [routerLink]="['/ft-triplet-result']"
              *ngIf="role == 'Administrator'"
              >FT Triplets Result (OBS)</a
            >
            <a
              [routerLink]="['/second-trimester-result']"
              *ngIf="role == 'Administrator'"
              >ST Result (OBS)</a
            >
            <a
              [routerLink]="['/third-trimester-result']"
              *ngIf="role == 'Administrator'"
              >TT Result (OBS)</a
            >
            <a [routerLink]="['/receipt']" *ngIf="role == 'Administrator'"
              >Receipt</a
            >
            <a [routerLink]="['/file']" *ngIf="role == 'Administrator'">File</a>
            <a [routerLink]="['/log']" *ngIf="role == 'Administrator'">Log</a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion
        *ngIf="
          role == 'Administrator' ||
          role == 'Front Desk' ||
          role == 'Scan' ||
          role == 'X-ray' ||
          role == 'Cashier' ||
          role == 'Lab Scientist' ||
          role == 'Lab Supervisor' ||
          role == 'Lab' ||
          role == 'Result Typing' ||
          role == 'Dispatch' ||
          role == 'Result Printing'
        "
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-item">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/medical-records.svg"
                  alt="not"
                />
                <div>Patient</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/register']"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Patient Registration</a
            >
          </div>
          <div class="links">
            <a [routerLink]="['/patient']">Patients</a>
          </div>
          <div class="links">
            <a
              [routerLink]="['/print-invoice']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Invoice Print
            </a>
            <a
              (click)="openLocalPointment()"
              *ngIf="role == 'Administrator' || role == 'Front Desk'"
              >Appointments
            </a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion
        *ngIf="role == 'Administrator' || role == 'Scan' || role == 'X-ray'"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-item">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/scan.svg"
                  alt="not"
                />
                <div>Radiology</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/scan']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Scan'"
              >OBS
            </a>
            <a
              [routerLink]="['/xray']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' || role == 'X-ray' || role == 'Scan'
              "
              >Scan and Medical IMG
            </a>
            <a
              [routerLink]="['/radiology']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' || role == 'X-ray' || role == 'Scan'
              "
              >Radiology
            </a>
            <a
              [routerLink]="['/print-xray']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' || role == 'X-ray' || role == 'Scan'
              "
              >Print Scan
            </a>
            <a
              [routerLink]="['/radiology-print']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' || role == 'X-ray' || role == 'Scan'
              "
              >Print Radiology
            </a>
            <a [routerLink]="['/result']">Result Template</a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="role == 'Administrator' || role == 'Cashier'">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/payment.svg"
                  alt="not"
                />
                <div>Payment</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/payment']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Cashier'"
              >Settlement Bill
            </a>
            <a
              [routerLink]="['/ledger']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Cashier'"
              >Bill Ledger
            </a>
            <a
              [routerLink]="['/print-receipt']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Cashier'"
              >Receipt Print
            </a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion
        *ngIf="
          role == 'Administrator' ||
          role == 'Lab Scientist' ||
          role == 'Lab Supervisor' ||
          role == 'Lab' ||
          role == 'Result Typing' ||
          role == 'Dispatch' ||
          role == 'Result Printing' ||
          role == 'Doctor'
        "
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-tem">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/laboratory.svg"
                  alt="not"
                />
                <div>Diagnostic</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/collect-sample']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Lab'"
              >Sample Collection
            </a>
            <a
              [routerLink]="['/acknowledge-sample']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Lab Scientist' ||
                role == 'Lab Supervisor'
              "
              >Acknowledge
            </a>
            <a
              [routerLink]="['/encounters']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Lab Scientist' ||
                role == 'Lab Supervisor' ||
                role == 'Result Typing'
              "
              >Result Entry
            </a>
            <a
              [routerLink]="['/finalise-encounter']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'Doctor'"
              >Result Finalized
            </a>
            <a
              [routerLink]="['/result-print']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Dispatch' ||
                role == 'Result Printing' ||
                role == 'Lab Supervisor'
              "
              >Result Print
            </a>
            <a
              [routerLink]="['/result-dispatch']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Dispatch' ||
                role == 'Result Printing'
              "
              >Result Dispatch
            </a>
            <a [routerLink]="['/result']">Result Template</a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion
        *ngIf="
          role == 'Administrator' ||
          role == 'Account' ||
          role == 'Cashier' ||
          role == 'HR'
        "
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header class="nav-tem">
            <mat-panel-title>
              <div class="head">
                <img
                  class="icon"
                  src="assets/icons/Modules/application.svg"
                  alt="not"
                />
                <div>Report</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="links">
            <a
              [routerLink]="['/report']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="
                role == 'Administrator' ||
                role == 'Account' ||
                role == 'Cashier' ||
                role == 'HR' ||
                role == 'Front Desk'
              "
              >Report
            </a>
            <a
              [routerLink]="['/export-price']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'HR'"
              >Print Price
            </a>
            <a
              [routerLink]="['/export-user']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'HR'"
              >Print User
            </a>
            <a
              [routerLink]="['/export-employee']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'HR'"
              >Print Employee
            </a>
            <a
              [routerLink]="['/export-dr']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
              *ngIf="role == 'Administrator' || role == 'HR'"
              >Print Ref DR
            </a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-panel-title (click)="logout()" class="logout">
        <div class="head">
          <img class="icon" src="assets/icons/Modules/logout.svg" alt="not" />
          <div>Logout</div>
        </div>
      </mat-panel-title>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->
